import { z } from "zod";

import { apiPost } from "@/api/client";
import type { Yorum, YorumlarOzet } from "@/api/yorumlar";
import { t } from "@/i18n";

/**
 * Yorumlar AI analizi — `POST /api/v2/ai/analyze/free-analyze` (bkz.
 * backend/app/core/api/ai.py `ai_analyze` "eski yol" govdesi: `{context,
 * period, user_prompt}`). BILEREK `src/api/ai.ts`'e (P5-F2'nin dosyasi)
 * DOKUNULMAZ/ITHAL EDILMEZ — gorev talimati: "kendi basit modalin
 * features/yorumlar altinda"; bu yuzden istek/yanit semasi burada, izole,
 * tekrar tanimlanir. `apiPost`/`apiClient.ts` paylasilan iskelet oldugu icin
 * (kimseye ozel degil) serbestce kullanilir.
 *
 * `period: "today"` — `period_to_contract()` (app/imga/client.py) bunu
 * "day" contract degerine, "tek gunluk anlik goruntu" notuyla esler; yorum
 * listesi zaten "su an"ki bir kesit oldugu icin dogru secim budur.
 */

const aiAnalyzeResponseSchema = z
  .object({
    ok: z.boolean().optional(),
    request_id: z.string().optional(),
    response: z.object({
      answer_markdown: z.string(),
      charts_suggested: z.array(z.unknown()).optional(),
      follow_up_prompts: z.array(z.string()).optional(),
    }),
    meta: z.record(z.string(), z.unknown()).optional(),
  })
  .passthrough();
export type AiAnalyzeResponse = z.infer<typeof aiAnalyzeResponseSchema>;

/** IMGA butcesi/gecikmesi icin baglami kucuk tutar (bkz. proje hafizasi: IMGA gecikme notu). */
const MAX_YORUM_ADEDI = 50;
const MAX_GOVDE_UZUNLUGU = 300;

function ozetlenmisYorum(y: Yorum) {
  return {
    rating: y.rating ?? 0,
    product_name: y.product_name ?? null,
    body: (y.body ?? "").slice(0, MAX_GOVDE_UZUNLUGU),
  };
}

export function yorumlarAiBaglami(yorumlar: Yorum[], ozet: YorumlarOzet, filtre: string) {
  return {
    filtre,
    ozet,
    yorumlar: yorumlar.slice(0, MAX_YORUM_ADEDI).map(ozetlenmisYorum),
  };
}

export function analyzeYorumlar(
  yorumlar: Yorum[],
  ozet: YorumlarOzet,
  filtre: string,
  userPrompt?: string,
): Promise<AiAnalyzeResponse> {
  return apiPost("/api/v2/ai/analyze/free-analyze", aiAnalyzeResponseSchema, {
    context: yorumlarAiBaglami(yorumlar, ozet, filtre),
    period: "today",
    user_prompt: userPrompt ?? t("yorumlar.ai.default_prompt"),
  });
}
